module.exports = __webpack_public_path__ + "img/Selection_011.2718079b.png";